module.exports = __webpack_public_path__ + "img/about-image.0b19700a.png";